import React, { useState, useEffect, useRef, useCallback } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

// IMPORT IMAGES
import photo4 from "../assets/photos/Best managed project_Shell India.JPG";
import photo5 from "../assets/photos/CGD Company of the year_IGL.JPG";
import photo1 from "../assets/photos/Exploration Company of the Year_ONGC.JPG";
import photo8 from "../assets/photos/Innovator of the year (Team)_ IOCL.JPG";
import photo9 from "../assets/photos/Innovator of the year(Team)_MRPL.JPG";
import photo2 from "../assets/photos/Oil & Gas Production company of the year_Oil India.JPG";
import photo3 from "../assets/photos/Oil & Gas Production company of the year_Sun Petrochemical.JPG";
import photo12 from "../assets/photos/Oil Marketing Company of the year_HPCL.JPG";
import photo6 from "../assets/photos/Pipeline Transportation company of the year_BPCL.JPG";
import photo7 from "../assets/photos/Refinery of the year_Reliance Industries.JPG";
import photo10 from "../assets/photos/Young Achiever_Female.JPG";
import photo11 from "../assets/photos/Young Achiever_Male.JPG";

const photos = [
  {
    src: photo1,
    label:
      "Exploration Company of the Year  — Oil and Natural Gas Corporation Limited",
  },
  {
    src: photo2,
    label:
      "Oil and Gas Production Company of the Year (>=1 MTOE)  — Oil India Limited",
  },
  {
    src: photo3,
    label:
      "Oil and Gas Production Company of the Year (<1 MTOE)  — Sun Petrochemicals Private Limited",
  },
  {
    src: photo4,
    label: "Best Managed Project of the Year  — Shell Companies in India",
  },
  {
    src: photo5,
    label:
      "City Gas Distribution Company of the Year  — Indraprastha Gas Limited",
  },
  {
    src: photo6,
    label:
      "Pipeline Transportation Company of the Year  — Bharat Petroleum Corporation Limited",
  },
  {
    src: photo7,
    label:
      "Refinery of the Year  — Reliance Industries Limited (SEZ Jamnagar Refinery)",
  },
  {
    src: photo8,
    label: "Innovator of the Year (Team)  — Indian Oil Corporation Limited ",
  },
  {
    src: photo9,
    label:
      "Innovator of the Year (Team)  — Mangalore Refinery & Petrochemicals Limited ",
  },
  {
    src: photo10,
    label:
      "Young Achiever of the Year (Female)  — Vanashree Mhatre, Pipeline Infrastructure Limited",
  },
  {
    src: photo11,
    label:
      "Young Achiever of the Year (Male)  — Karthick R, Mangalore Refinery & Petrochemicals Limited",
  },
  {
    src: photo12,
    label:
      "Oil Marketing Company of the Year  — Hindustan Petroleum Corporation Limited",
  },
];

const INTERVAL = 3000;

const PhotoGallery = () => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  // NEXT
  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % photos.length);
  }, []);

  // PREV
  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + photos.length) % photos.length);
  }, []);

  // AUTO SLIDE
  useEffect(() => {
    timerRef.current = setInterval(next, INTERVAL);
    return () => clearInterval(timerRef.current);
  }, [next]);

  // PAUSE ON HOVER
  const pause = () => clearInterval(timerRef.current);
  const resume = () => {
    timerRef.current = setInterval(next, INTERVAL);
  };

  // KEYBOARD SUPPORT
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [prev, next]);

  // PRELOAD NEXT IMAGE
  useEffect(() => {
    const img = new Image();
    img.src = photos[(current + 1) % photos.length].src;
  }, [current]);

  return (
    <div className="sidebar-content">
      <div className="content-box" style={{ padding: "20px" }}>
        <h2 style={{ marginBottom: "10px" }}>Photo Gallery</h2>

        <div
          onMouseEnter={pause}
          onMouseLeave={resume}
          style={{
            position: "relative",
            width: "100%",
            height: "auto", // ✅ IMPORTANT
            maxHeight: "850px", // (optional)
            overflow: "hidden",
            borderRadius: "12px",
            background: "#000",
          }}
        >
          {/* SLIDER */}
          <div
            style={{
              display: "flex",
              height: "100%",
              transform: `translateX(-${current * 100}%)`,
              transition: "transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)",
            }}
          >
            {photos.map((photo, index) => (
              <div
                key={index}
                style={{
                  minWidth: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#000",
                }}
              >
                <LazyLoadImage
                  src={photo.src}
                  alt={photo.label}
                  effect="blur"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "bottom",
                  }}
                />
              </div>
            ))}
          </div>

          {/* CAPTION */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              padding: "20px",
              background: "linear-gradient(transparent, rgba(0,0,0,0.8))",
              color: "#fff",
              fontSize: "14px",
            }}
          >
            {photos[current].label}
          </div>

          {/* ARROWS */}
          <button onClick={prev} style={arrowStyle("left")}>
            ‹
          </button>
          <button onClick={next} style={arrowStyle("right")}>
            ›
          </button>

          {/* COUNTER */}
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              padding: "4px 10px",
              borderRadius: "20px",
              fontSize: "12px",
            }}
          >
            {current + 1} / {photos.length}
          </div>
        </div>

        {/* DOTS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "12px",
            gap: "6px",
          }}
        >
          {photos.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              style={{
                width: i === current ? "20px" : "8px",
                height: "8px",
                borderRadius: "4px",
                border: "none",
                background: i === current ? "#1a56db" : "#ccc",
                transition: "all 0.3s",
                cursor: "pointer",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// ARROW STYLE
const arrowStyle = (side) => ({
  position: "absolute",
  top: "50%",
  [side]: "10px",
  transform: "translateY(-50%)",
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  background: "rgba(255,255,255,0.2)",
  border: "none",
  color: "#fff",
  fontSize: "22px",
  cursor: "pointer",
  backdropFilter: "blur(6px)",
});

export default PhotoGallery;
